import { createGlobalStyle } from "styled-components";

interface StyleProps {
  deviceType?: string;
}

export const CurrencyPageStyle = createGlobalStyle<StyleProps>`

/* Background color classes */
.bg-light-grey {
  background-color: #F2F2F2;
}

/* Desktop styles - all desktop-specific overrides */
@media (min-width: 1024px) {
  ${(props) =>
    props.deviceType === "lg"
      ? `
    /* Top banner section styling for lg deviceType */
    #top-banner {
        background: url(//imgak.mmtcdn.com/pwa_v3/pwa_commons_assets/desktop/bg6.jpg) !important;
        background-repeat: no-repeat !important;
        padding-bottom: 40px !important;
        min-height: auto !important;
        padding: 0 !important;
        margin: 0 !important;
    }

    /* Top banner container styles */
    .top-banner__container {
        margin: 0 auto !important;
        padding-top: 32px !important;
        max-width: 1200px !important;
    }

    .top-banner__wrapper {
        padding-bottom: 40px;
        padding-top: 16px;
    }

    .top-banner__title {
        font-size: 36px !important;
        line-height: 43.2px !important; /* 1.2em of 36px */
        font-weight: 900 !important;
        color: #FFFFFF !important;
        margin: 0 !important;
    }

    .top-banner__breadcrumb {
        margin-top: 16px !important;
    }

    /* Header styling for lg deviceType */
    header {
        position: sticky !important;
        top: 0 !important;
        z-index: 10 !important;
        background-color: #fff !important;
        padding: 18px 0 !important;
    }

    .currencyFacts__list::after {
        display: none !important;
    }

    /* Remove negative margins for lg deviceType */
    .container.negativeMargin {
        margin-top: 0 !important;
    }

    .pageContainer.pageContainer_margin {
        margin-top: 0 !important;
    }

    /* Container margin-top for lg deviceType */
    .container--margin-top-24 {
        margin-top: 24px !important;
    }

    /* Section wrapper styling for lg deviceType */
    .sectionWrapper {
        background-color: #fff;
        border-radius: 16px;
        padding: 32px 24px;
        margin-bottom: 48px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    /* Remove pageContent margin for desktop to prevent empty space */
    .pageContent {
        margin: 0 auto;
    }

    /* Typography improvements for lg deviceType */
    .tripMoneySection h2 {
        font-size: 22px !important;
        line-height: 26.4px !important;
        font-weight: 900 !important;
        color: #000 !important;
    }

    .tripMoneySection p,
    .tripMoneySection .description {
        font-size: 16px !important;
        line-height: 19.2px !important;
        font-weight: 400 !important;
        color: #4A4A4A !important;
    }

    /* Container card improvements */
    .container__card {
        background-color: #fff;
        border-radius: 8px;
        padding: 24px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        margin-bottom: 16px;
    }

    .container__card.container__cardAlign {
        border: 1px solid #D8D8D8 !important;
        border-radius: 8px !important;
        padding: 16px 8px !important;
    }

    .tripmoneyImgWrap::after {
        content: '' !important;
        position: absolute !important;
        top: -55px !important;
        right: -33px !important;
        width: 1px !important;
        border-right: 1px dotted #d5d5d5 !important;
        height: 160px !important;    
    }

    /* Hide separators on desktop by default */
    .separator {
        display: none !important;
    }

    /* Identification section specific styling - no extra card styling */
    .identification-section {
        background-color: transparent;
        padding: 0;
        margin: 0;
        box-shadow: none;
        border-radius: 0;
    }

    .identification-section .tripMoneySection {
        background-color: transparent;
        padding: 0;
        margin: 0;
        box-shadow: none;
        border-radius: 0;
    }

    .identification-section h2 {
        font-size: 22px !important;
        line-height: 26.4px !important;
        font-weight: 900 !important;
        color: #000 !important;
        margin-bottom: 24px !important;
    }

    /* UL section styling to match Figma */
    .identification-section ul {
        max-width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
        list-style: none !important;
    }

    .identification-section ul li {
        font-size: 16px !important;
        line-height: 24px !important;
        font-weight: 400 !important;
        color: #333333 !important;
        margin-bottom: 40px !important;
        padding-bottom: 0 !important;
        border-bottom: none !important;
    }

    /* Enhanced styling for list item content */
    .identification-section ul li span {
        font-size: 16px !important;
        line-height: 24px !important;
        font-weight: 400 !important;
        color: #333333 !important;
    }

    .identification-section ul li:last-child {
        margin-bottom: 0 !important;
    }

    /* Image styling for identification section - improved spacing */
    .identification-section .counterFietImgWrap {
        display: flex !important;
        align-items: flex-start !important;
        justify-content: center !important;
        flex: 0 0 auto !important;
        width: 280px !important;
        min-width: 280px !important;
        padding-left: 24px !important;
    }

    .identification-section .counterFietImgWrap img {
        max-width: 100% !important;
        height: auto !important;
        object-fit: contain !important;
        border-radius: 8px !important;
    }

    /* Green check icon styling */
    .identification-section .greenCheckImg {
        width: 16px !important;
        height: 16px !important;
        margin-right: 12px !important;
        flex-shrink: 0 !important;
    }

    /* List item flex styling */
    .identification-section ul li.makeFlex {
        display: flex !important;
        align-items: flex-start !important;
        gap: 12px !important;
        margin-bottom
    }

    .identification-section ul li span {
        flex: 1 !important;
    }

    /* Mobile image wrapper - hide on desktop */
    .identification-section .counterFietImgWrapMweb {
        display: none !important;
    }

    /* Identification section header styling - reduced spacing */
    .identification-section h2.appendBottom30 {
        font-size: 22px !important;
        line-height: 26.4px !important;
        font-weight: 900 !important;
        color: #000 !important;
        margin-bottom: 12px !important;
    }

    /* CurrencySEOMarkdown with divider line */
    .identification-section .appendBottom20 {
        font-size: 16px !important;
        line-height: 19.2px !important;
        font-weight: 400 !important;
        color: #4A4A4A !important;
        margin-bottom: 16px !important;
        padding-bottom: 16px !important;
        border-bottom: 1px dashed #D8D8D8 !important;
    }

    /* Section flex layout - improved spacing */
    .identification-section .tripMoneySection.makeFlex {
        display: flex !important;
        gap: 32px !important;
        align-items: flex-start !important;
        justify-content: space-between !important;
    }

    .identification-section .tripMoneySection.makeFlex > div:first-child {
        flex: 1 1 auto !important;
        max-width: calc(100% - 320px) !important;
        padding-right: 16px !important;
    }

    .identification-section .tripMoneySection.makeFlex > div:last-child {
        flex: 0 0 auto !important;
        width: 280px !important;
    }

    /* Identification section specific styling for lg deviceType */
    .identification-wrapper--lg .sectionWrapper {
        padding: 0 !important;
    }

    .identification-container--lg {
        display: flex !important;
        padding: 32px 24px !important;
        gap: 20px !important;
        align-items: flex-start !important;
        justify-content: space-between !important;
        flex-wrap: nowrap !important;
    }

    .identification-container--lg > .tripMoneySection {
        display: flex !important;
        width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
    }

    .identification-container--lg .tripMoneySection > div:first-child {
        flex: 1 1 auto !important;
        max-width: 60% !important;
        min-width: 0 !important;
        padding-right: 16px !important;
    }

    .identification-container--lg .tripMoneySection > div:last-child {
        flex: 0 0 auto !important;
        width: 35% !important;
        max-width: 300px !important;
        min-width: 250px !important;
        padding-left: 16px !important;
    }

    /* UL and image styling within the flex container */
    .identification-container--lg ul {
        max-width: 100% !important;
        width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
        list-style: none !important;
    }

    .identification-container--lg ul li {
        font-size: 16px !important;
        line-height: 24px !important;
        font-weight: 400 !important;
        color: #333333 !important;
        margin-bottom: 40px !important;
        padding-bottom: 0 !important;
        border-bottom: none !important;
    }

    .identification-container--lg ul li:last-child {
        margin-bottom: 0 !important;
    }

    .identification-container--lg ul li.makeFlex {
        display: flex !important;
        align-items: flex-start !important;
        gap: 12px !important;
    }

    .identification-container--lg ul li span {
        flex: 1 !important;
        font-size: 16px !important;
        line-height: 24px !important;
        font-weight: 400 !important;
        color: #333333 !important;
    }

    .identification-container--lg .greenCheckImg {
        width: 16px !important;
        height: 16px !important;
        margin-right: 0 !important;
        flex-shrink: 0 !important;
    }

    .identification-container--lg .counterFietImgWrap {
        display: flex !important;
        align-items: flex-start !important;
        justify-content: center !important;
        height: auto !important;
    }

    .identification-container--lg .counterFietImgWrap img {
        max-width: 100% !important;
        height: auto !important;
        object-fit: contain !important;
        border-radius: 8px !important;
    }

    /* Remove box shadow from container__card for lg deviceType */
    .container__card {
        box-shadow: none !important;
        background-color: transparent !important;
        border-radius: 0 !important;
        padding: 0 !important;
        margin-bottom: 0 !important;
    }

    /* Currency Converter styling for lg deviceType */
    .sectionWrapper .h2 {
        font-size: 22px !important;
        line-height: 26.4px !important;
        font-weight: 900 !important;
        color: #000 !important;
        margin-bottom: 24px !important;
    }

    .sectionWrapper .capSulesList {
        display: grid !important;
        grid-template-columns: repeat(4, 1fr) !important;
        gap: 16px !important;
        margin-bottom: 24px !important;
        list-style: none !important;
        padding: 0 !important;
    }

    .sectionWrapper .capSulesList li {
        box-shadow: none !important;
    }

    .sectionWrapper .capSulesList.grid5 {
        grid-template-columns: repeat(4, 1fr) !important;
    }

    .sectionWrapper .capsule {
        background-color: #F5F5F5 !important;
        border-radius: 5px !important;
        padding: 16px 20px !important;
        text-align: center !important;
        transition: all 0.2s ease !important;
        min-height: 48px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        border: 1px solid #D8D8D8 !important;
    }


    /* Alternative approach: Hide capsules beyond the first 4 */
    .sectionWrapper .capSulesList:not(.showAll) .capsule:nth-child(n+5) {
        display: none !important;
    }

    .sectionWrapper .capSulesList.grid5:not(.showAll) .capsule:nth-child(n+5) {
        display: none !important;
    }

    .sectionWrapper .capsule a {
        color: #008CFF !important;
        text-decoration: none !important;
        font-size: 12px !important;
        font-weight: 900 !important;
        line-height: 17px !important;
        display: block !important;
        width: 100% !important;
    }


    .sectionWrapper .viewMore {
        text-align: left !important;
        margin-top: 24px !important;
        margin-bottom: 0 !important;
    }

    .sectionWrapper .viewMore__cta {
        color: #008CFF !important;
        text-decoration: none !important;
        font-size: 16px !important;
        font-weight: 700 !important;
        cursor: pointer !important;
        padding: 8px 16px !important;
        border-radius: 6px !important;
        transition: all 0.2s ease !important;
        display: inline-block !important;
        background-color: transparent !important;
        border: none !important;
    }

    .tripMoneySection__bestRateBuy li {
        width: 320px !important;
    }

    .productRangeList li {
        border-bottom: none !important;
    }

    /* Hide containerImg for lg deviceType */
    .containerImg {
        display: none !important;
    }

    /* Quick Facts section styling for lg deviceType */
    .container__card--yellow {
        background-color: transparent !important;
        border: none !important;
        box-shadow: none !important;
        padding: 0 !important;
    }

    .currencyFacts__heaading {
        display: flex !important;
        align-items: center !important;
        gap: 12px !important;
        margin-bottom: 24px !important;
    }

    .currencyFacts__heaading .quickfactsImg {
        width: 24px !important;
        height: 24px !important;
        flex-shrink: 0 !important;
    }

    .currencyFacts__heaading h2 {
        font-size: 20px !important;
        font-weight: 600 !important;
        line-height: 24px !important;
        color: #333333 !important;
        margin: 0 !important;
    }

    /* Header row styling for lg deviceType */
    .currencyFacts__header-row {
        background-color: #F5F5F5 !important;
        border-bottom: 2px solid #E0E0E0 !important;
    }

    .currencyFacts__header-cell {
        text-align: center !important;
        padding: 20px !important;
        border: none !important;
    }

    .currencyFacts__heaading--table {
        justify-content: center !important;
        align-items: center !important;
        gap: 12px !important;
        margin-bottom: 0 !important;
    }

    .currencyFacts__heaading--table .quickfactsImg {
        width: 28px !important;
        height: 28px !important;
    }

    .currencyFacts__heaading--table h2 {
        font-size: 18px !important;
        font-weight: 900 !important;
        line-height: 22px !important;
        color: #333333 !important;
        margin: 0 !important;
        text-align: center !important;
    }

    /* Hide the regular header for lg devices */
    .currencyFacts__heaading:not(.currencyFacts__heaading--table) {
        display: none !important;
    }

    .currencyFacts__list {
        width: 100% !important;
        border-collapse: collapse !important;
        border: none !important;
        border-radius: 8px !important;
        overflow: hidden !important;
    }

    .currencyFacts__list tbody tr {
        border: none !important;
        border-bottom: none !important;
    }

    /* Alternating row colors - 1st row (odd) */
    .currencyFacts__list tbody tr:nth-child(odd) {
        background-color: #FFF7DD !important;
    }

    /* Alternating row colors - 2nd row (even) */
    .currencyFacts__list tbody tr:nth-child(even) {
        background-color: #FFFBEC !important;
    }

    .currencyFacts__list tbody tr td {
        padding: 16px 20px !important;
        border: none !important;
        border-bottom: none !important;
        vertical-align: middle !important;
    }

    .currencyFacts__list tbody tr td:first-child {
        width: 45% !important;
        padding-right: 20px !important;
        font-weight: 900 !important;
    }

    .currencyFacts__list tbody tr td:last-child {
        width: 55% !important;
    }

    /* Left column (labels) styling */
    .currencyFacts__list tbody tr td span.latoBold {
        font-size: 14px !important;
        font-weight: 500 !important;
        line-height: 20px !important;
        color: #666666 !important;
        font-family: 'Lato', sans-serif !important;
    }

    /* Right column (values) styling */
    .currencyFacts__list tbody tr td span {
        font-size: 14px !important;
        font-weight: 400 !important;
        line-height: 20px !important;
        color: #333333 !important;
        font-family: 'Lato', sans-serif !important;
    }

    /* Ensure CurrencySEOMarkdown doesn't override our styles */
    .currencyFacts__list tbody tr td span p {
        font-size: 14px !important;
        font-weight: 400 !important;
        line-height: 20px !important;
        color: #333333 !important;
        margin: 0 !important;
    }

    /* Show all capsules when showAll class is applied - nth-child approach handles this */

    /* Hide separator in SectionWrapper */
    .sectionWrapper .separator {
        display: none !important;
    }

    /* Container width override for lg deviceType to match Figma design */
    .container {
        width: 1200px !important;
    }

    /* greySection padding override for lg deviceType */
    .greySection {
        padding: 20px 0 !important;
    }

    /* Remove padding-bottom and border-bottom from tripMoneySection for lg deviceType */
    .tripMoneySection {
        padding-bottom: 0 !important;
        border-bottom: none !important;
    }

    /* Add 44px padding-top to description section as per Figma design for lg deviceType */
    .tripMoneySection .about-description {
        padding-top: 44px !important;
    }

    /* Country list styling for lg deviceType as per Figma design */
    .countryList {
        display: flex !important;
        flex-wrap: wrap !important;
        gap: 16px !important;
        margin: 0 !important;
        padding: 0 !important;
        list-style: none !important;
    }

    .countryList li {
        display: flex !important;
        align-items: center !important;
        gap: 12px !important;
        padding: 8px !important;
        background: #FFFFFF !important;
        border: 1px solid #D8D8D8 !important;
        border-radius: 16px !important;
        box-shadow: none !important;
        transition: none !important;
        flex: 0 0 calc((100% - 80px) / 6) !important;
        min-width: 0 !important;
        width: calc((100% - 80px) / 6) !important;
    }

    .countryList li:hover {
        box-shadow: none !important;
        border-color: #D8D8D8 !important;
        background: #FFFFFF !important;
        transform: none !important;
    }

    .countryList .countryImg {
        width: 40px !important;
        height: 40px !important;
        border-radius: 20px !important;
        object-fit: cover !important;
        flex-shrink: 0 !important;
    }

    .countryList .font16.latosemiBold,
    .countryList a.font16.latosemiBold {
        font-size: 16px !important;
        font-weight: 700 !important;
        line-height: 1.2 !important;
        color: #022135 !important;
        text-decoration: none !important;
        margin: 0 !important;
        padding: 0 !important;
    }

    .countryList a.font16.latosemiBold:hover {
        color: #022135 !important;
        text-decoration: none !important;
    }

    /* FAQ section styles for lg deviceType - copied from CurrencyRatePageTemplate */
    .faqList {
        margin-top: 16px !important;
    }

    .faqList li h4.question {
        font-size: 16px !important;
        line-height: 16px !important;
        padding: 12px 0px !important;
        font-weight: 400 !important;
    }

    .faqList li h4.question::after {
        top: 12px !important;
    }

    .faqList li:hover {
        box-shadow: none !important;
        border-color: transparent !important;
        background-color: transparent !important;
    }

    .faqList li:hover h4.question {
        background-color: transparent !important;
        box-shadow: none !important;
        border-radius: none !important;
    }

    .faqList li div.answer {
        font-size: 14px !important;
        margin-bottom: 16px !important;
    }

    /* Add 24px padding-top to text below country cards as per Figma design */
    .countries-accepting-desc {
        padding-top: 24px !important;
    }

    /* Process of exchanging section styling for lg deviceType as per Figma design */
    .process-divider {
        width: 100% !important;
        height: 1px !important;
        border-top: 1px dashed #D8D8D8 !important;
        margin: 24px 0 !important;
    }

    .process-list {
        display: flex !important;
        flex-direction: column !important;
        gap: 40px !important;
        padding: 0 12px !important;
        box-shadow: none !important;
        border: none !important;
        background: transparent !important;
    }

    .process-item {
        display: flex !important;
        flex-direction: column !important;
        gap: 8px !important;
    }

    .process-item-header {
        display: flex !important;
        align-items: flex-start !important;
        gap: 12px !important;
    }

    .process-icon {
        width: 5px !important;
        height: 12px !important;
        background-color: #16477F !important;
        border-radius: 2px !important;
        margin-top: 8px !important;
        flex-shrink: 0 !important;
    }

    .process-title {
        font-family: Lato !important;
        font-size: 22px !important;
        font-weight: 900 !important;
        line-height: 1.2 !important;
        color: #000000 !important;
        margin: 0 !important;
        flex: 1 !important;
    }

    .process-item .appendBottom10 {
        margin-bottom: 8px !important;
        font-family: Lato !important;
        font-size: 16px !important;
        font-weight: 400 !important;
        line-height: 1.2 !important;
        color: #4A4A4A !important;
    }

    .process-item ul {
        margin: 0 !important;
        padding: 0 !important;
        list-style: none !important;
    }

    .process-item ul li {
        margin-bottom: 8px !important;
        display: flex !important;
        align-items: flex-start !important;
        gap: 8px !important;
    }

    .process-item ul li:last-child {
        margin-bottom: 0 !important;
    }

    .process-item ul li span {
        font-family: Lato !important;
        font-size: 16px !important;
        font-weight: 400 !important;
        line-height: 1.2 !important;
        color: #4A4A4A !important;
    }

    /* Hide green check image for lg deviceType */
    .process-item .greenCheckImg {
        display: none !important;
    }
  `
      : ""}
}
`;
